<template>
    <div>
        <v-dialog value="true" width="500" persistent>
            <v-card>
                <v-card-title class="headline primary white--text" primary-title>
                    Extinguir {{ $tc("pt_br.documento").toLowerCase() }}
                </v-card-title>

                <v-card-text class="co-nova-extincao">
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                            <v-textarea
                                label="Justificativa"
                                placeholder="Texto"
                                name="Texto"
                                class="required-field"
                                v-model="value.descricao"
                                v-validate="'required'"
                                :error-messages="errors.collect('Texto')"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#ccc" text @click="$emit('cancelar')">
                        Cancelar
                    </v-btn>
                    <v-btn color="green" text @click="salvar">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <clm-dialog v-model="mostrarConfirmacao">
            <clm-ops sentimento="assustado">
                <div slot="titulo">Eita! Deixa eu confirmar uma coisa...</div>
                <div slot="subtitulo">Você quer mesmo extinguir o {{ $tc("pt_br.documento").toLowerCase() }}?</div>
                <div slot="acoes">
                    <div class="principal">
                        <a @click="confirmar">Sim, claro!</a>
                    </div>
                    <div class="secundaria">
                        <a @click="fecharConfirmacao">Não, obrigado</a>
                    </div>
                </div>
            </clm-ops>
        </clm-dialog>
    </div>
</template>

<script>
import ClmDialog from '@/commons/components/ClmDialog'
import ClmOps from '@/commons/components/ClmOps'

export default {
    name: 'novo-extincao',
    components: {ClmDialog, ClmOps},
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            mostrarConfirmacao: false
        }
    },
    methods: {
        abrirModalConfirmacao() {
            this.mostrarConfirmacao = true
        },
        fecharConfirmacao() {
            this.mostrarConfirmacao = false
        },
        confirmar() {
            this.$emit('extinguir')
            this.fecharConfirmacao()
        },
        async salvar() {
            const valido = await this.$validator._base.validateAll()
            if (!valido) return

            this.abrirModalConfirmacao()
        }
    }
}
</script>